import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../../../layouts/Main';
import Container from '../../../../../components/Container';
import PageBreadcrumbs from '../../../../../components/PageBreadcrumbs';
import BankDepository from './BankDepository';
import BankList from './BankList';

const BankDepositorySetUp = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <BankDepository></BankDepository>
        <BankList></BankList>
      </Container>
    </Main>
  );
};

export default BankDepositorySetUp;